// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import { HideFooter, HideHeader, OpenGraphImage, OpenGraphTitle } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

const AllProductsPage: React.ComponentType<PageProps> = ({ id }) => {
    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: AllProductsPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        supportsCategorySelection: true,
        pageType: "Content",
        fieldDefinitions: [HideHeader, HideFooter, OpenGraphTitle, OpenGraphImage],
    },
};

export default pageModule;

export const AllProductsPageContext = "AllProductsPage";
